import { Clock, Instagram, Mail, MapPin, Phone, Youtube } from "lucide-react";
import React from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "../../context/LanguageContext";
import Logo from '../../assets/images/logo_centru_inversed.png';

const Footer = () => {
  const { t, lang } = useLanguage();

  return (
    <footer className="bg-islamic-teal text-white">
      {/* Gold accent line */}
      <div className="h-1 bg-islamic-gold"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          {/* About */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img src={Logo} alt="Logo" className="w-14 h-14 md:w-24 md:h-24 object-cover rounded-sm" />

              <div>
                <h3 className="font-serif text-lg font-semibold">
                  {lang === "ar" ? "مسجد الرحمن" : "Masjid Ar-Rahman"}
                </h3>
                <p className="text-xs text-white/60">București, România</p>
              </div>
            </div>
            <p className="text-sm text-white/70 leading-relaxed">
              {t("home.description")}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold mb-4 text-islamic-gold">
              {t("home.quickLinks")}
            </h4>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/annonces"
                  className="text-sm text-white/70 hover:text-white transition-colors">
                  {t("nav.announcements")}
                </Link>
              </li>
              <li>
                <Link
                  to="/adeverinta"
                  className="text-sm text-white/70 hover:text-white transition-colors">
                  {t("nav.certificate")}
                </Link>
              </li>
              <li>
                <Link
                  to="/dons"
                  className="text-sm text-white/70 hover:text-white transition-colors">
                  {t("nav.donations")}
                </Link>
              </li>
              {/* <li>
                <Link
                  to="/about"
                  className="text-sm text-white/70 hover:text-white transition-colors">
                  {t("nav.about")}
                </Link>
              </li> */}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-semibold mb-4 text-islamic-gold">
              {t("contact.title")}
            </h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-3 text-sm text-white/70">
                <MapPin className="w-4 h-4 mt-0.5 shrink-0 text-islamic-gold" />
                <span>
                  Strada Muntii Gurghiului nr 50-56 060316 BUCURESTI Romania
                </span>
              </li>
              <li className="flex items-center gap-3 text-sm text-white/70">
                <Phone className="w-4 h-4 shrink-0 text-islamic-gold" />
                <span>+40 21 314 5678</span>
              </li>
              <li className="flex items-center gap-3 text-sm text-white/70">
                <Mail className="w-4 h-4 shrink-0 text-islamic-gold" />
                <span>contact@musulman.ro</span>
              </li>
              <li className="flex items-center gap-3 text-sm text-white/70">
                <Clock className="w-4 h-4 shrink-0 text-islamic-gold" />
                <span>{t("contact.openDaily")}: Fajr - Isha</span>
              </li>
            </ul>
          </div>

          {/* Social */}
          <div>
            <h4 className="font-semibold mb-4 text-islamic-gold">
              {t("footer.followUs")}
            </h4>
            <div className="flex gap-3">
              <a
                href="https://chat.whatsapp.com/F6EGOlIThco0wdHEtPfsUX"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-lg bg-white/10 flex items-center justify-center hover:bg-white/20 transition-colors"
                data-testid="social-whatsapp">
                <svg
                  className="w-5 h-5"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" />
                </svg>
              </a>
              <a
                href="https://www.youtube.com/@masjidarrahmanbucharest"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-lg bg-white/10 flex items-center justify-center hover:bg-white/20 transition-colors"
                data-testid="social-youtube">
                <Youtube className="w-5 h-5" />
              </a>
              <a
                href="https://www.instagram.com/semilunacentre"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-lg bg-white/10 flex items-center justify-center hover:bg-white/20 transition-colors"
                data-testid="social-instagram">
                <Instagram className="w-5 h-5" />
              </a>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="mt-12 pt-8 border-t border-white/10 text-center">
          <p className="text-sm text-white/60">&copy; {new Date().getFullYear()} {t("footer.copyright")}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
